module.exports = __webpack_public_path__ + "static/media/signage-indoor-img26.1be82f46.jpg";